import { render, staticRenderFns } from "./OrderDeliveryDrawer.vue?vue&type=template&id=4e99627b"
import script from "./OrderDeliveryDrawer.vue?vue&type=script&lang=js"
export * from "./OrderDeliveryDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports